module.exports = "render() {\n  return (\n    <div style={{fontColor: 'red'}}>\n      CSS Example\n    </div>\n  );\n}\n"